import React from 'react';

interface SkeletonProps {
  className?: string;
  height?: string | number;
  width?: string | number;
  rounded?: boolean;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  height = '1rem',
  width = '100%',
  rounded = false,
}) => {
  return (
    <div
      className={`skeleton ${rounded ? 'rounded-full' : 'rounded'} ${className}`}
      style={{
        height,
        width,
      }}
    />
  );
};

export const SkeletonCard: React.FC = () => {
  return (
    <div className="p-4 space-y-3">
      <Skeleton height="200px" rounded />
      <Skeleton width="80%" />
      <Skeleton width="60%" />
      <div className="flex space-x-2">
        <Skeleton width="30%" />
        <Skeleton width="30%" />
      </div>
    </div>
  );
};

export const SkeletonList: React.FC<{ count?: number }> = ({ count = 3 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
}; 